export const retellOptions = [
    {
        label: "Add Web Pages",
        value: "add_web_pages"
    },
    {
        label: "Upload Files",
        value: "upload_files"
    },
    {
        label: "Add Text",
        value: "add_text"
    }
];

export const providerUploadOptions = {
    "retell" : [
        {
            label: "Add URL",
            value: "add_web_pages",
            desc: "Let your agent learn from any public website.",
            icon : "fi-rr-earth-americas",
            header:"Add URL",
        },
        {
            label: "Upload Files",
            value: "upload_files",
            desc: "Let your agent learn from documents.",
            icon: "fi-rr-document-signed",
            header:"Upload File",
        },
        {
            label: "Add Text",
            value: "add_text",
            desc: "Let your agent learn from plain text.",
            icon: "fi-rr-clip",
            header:"Add Text",
        }
    ],
    "vapi" : [
        {
            label: "Upload Files",
            value: "upload_files",
            desc: "Let your agent learn from documents.",
            icon: "fi-rr-document-signed",
            header:"Upload File",
        }
    ]
};